import React, {Component} from 'react';
import * as R from 'ramda';

import ApprovalCheckmark from 'js/components/approval_checkmark';
import Button from 'js/components/button';
import DisapprovalXMark from 'js/components/disapproval_x_mark';
import GuidelinesChecklist from 'js/components/guidelines_checklist';
import GuidelinesSelectList from 'js/components/guidelines_select_list';
import WorkflowPanel from 'js/components/workflow_panel';
import {isDoGuideline} from 'js/common/guideline_helper';
import CampaignGuidelinesListEmbed from 'js/components/campaign_guidelines_embed';
import {FeatureFlag} from 'react-launch-darkly';

import 'scss/layout.scss';
import './index.scss';

const modes = {
    VIEW: 'view',
    SELECT: 'select'
};

export default class GuidelinesViewOrSelect extends Component {
    static defaultProps = {
        onNext: R.identity
    };

    constructor(props) {
        super(props);
        this.state = {
            mode: modes.VIEW,
            guidelines: props.guidelines
        };

        this.renderLegacyGuidelines = this.renderLegacyGuidelines.bind(this);
    }

    UNSAFE_componentWillReceiveProps({guidelines: newGuidelines}) {
        const {mode, guidelines} = this.state;
        const sameGuidelines = R.equals(
            R.pluck('guideline', guidelines),
            R.pluck('guideline', newGuidelines)
        );
        this.setState({
            mode: sameGuidelines ? mode : modes.VIEW,
            guidelines: newGuidelines
        });
    }

    isDoGuidelines() {
        const {guidelines} = this.state;
        return R.any(isDoGuideline, guidelines);
    }

    isViewMode() {
        const {mode} = this.state;
        return mode === modes.VIEW;
    }

    onChange = guidelines => {
        this.setState({guidelines});
    };

    onSelectGuidelines = () => {
        this.setState({mode: modes.SELECT});
    };

    onSelectGuidelinesCancel = () => {
        this.setState({
            mode: modes.VIEW,
            guidelines: this.props.guidelines
        });
    };

    onNext = () => {
        const {guidelines} = this.state;
        this.props.onNext(guidelines);
    };

    renderIcon() {
        if (this.isDoGuidelines()) {
            return <ApprovalCheckmark inverted size={50} />;
        }
        return <DisapprovalXMark inverted size={50} />;
    }

    renderHeading() {
        if (this.isDoGuidelines()) {
            return this.isViewMode()
                ? 'Have these content MUSTs been met?'
                : 'Select the Missed Guidelines';
        }
        return this.isViewMode()
            ? 'Have these content DO NOTs been met?'
            : 'Select the Missed Guidelines';
    }

    renderButtons() {
        const {onPrevious} = this.props;
        if (this.isViewMode()) {
            return [
                onPrevious ? (
                    <Button back ghost key="prev" onClick={this.props.onPrevious}>
                        Prev
                    </Button>
                ) : null,
                <Button
                    danger
                    key="no"
                    className="guidelines-view-or-select__button"
                    onClick={this.onSelectGuidelines}
                >
                    No
                </Button>,
                <Button
                    primary
                    key="yes"
                    className="guidelines-view-or-select__button"
                    onClick={this.onNext}
                >
                    Yes
                </Button>
            ];
        }

        return [
            <Button secondary key="cancel" onClick={this.onSelectGuidelinesCancel}>
                Cancel
            </Button>,
            <Button primary key="next" onClick={this.onNext}>
                Next
            </Button>
        ];
    }

    renderLegacyGuidelines = () => {
        const {guidelines} = this.props;
        const ListComponent = this.isViewMode() ? GuidelinesChecklist : GuidelinesSelectList;
        return (
            <WorkflowPanel
                sameSizeButtons
                className="guidelines-view-or-select__form"
                buttons={this.renderButtons()}
            >
                <div className="guidelines-view-or-select__icon">{this.renderIcon()}</div>
                <div className="guidelines-view-or-select__heading">{this.renderHeading()}</div>
                <ListComponent guidelines={guidelines} onChange={this.onChange} />
            </WorkflowPanel>
        );
    };

    render() {
        return (
            <FeatureFlag
                flagKey="guidelines-support-rich-text"
                renderDefaultCallback={this.renderLegacyGuidelines}
                renderFeatureCallback={flagValue => {
                    if (flagValue === 'on') {
                        const isViewMode = this.isViewMode();
                        return (
                            // Adding the key causes the guidelines to rerender as needed when viewmode changes
                            <div key={`${isViewMode}-${this.props.operator}`}>
                                <div className="workflow-panel workflow-panel--same-size-buttons">
                                    <div className="guidelines-view-or-select__icon">
                                        {this.renderIcon()}
                                    </div>
                                </div>
                                <div className="guidelines-view-or-select__heading">
                                    {this.renderHeading()}
                                </div>
                                <div className="workflow-panel__buttons">
                                    {this.renderButtons()}
                                </div>

                                <CampaignGuidelinesListEmbed
                                    application="admin_brand"
                                    isActionsMenuShown={false}
                                    isFilterable={false}
                                    visibleOperators={[this.props.operator]}
                                    visibleCategories={['CONTENT_GUIDELINES']}
                                    campaignSlug={this.props.campaignSlug}
                                    campaignId=""
                                    isSelectable={!this.isViewMode()}
                                    onGuidelineSelect={(guideline, currentList) => {
                                        const newGuidelines = currentList.map(guideline => {
                                            return {
                                                guideline: guideline.legacyConcatValue,
                                                id: 'unknown',
                                                selected: guideline.isSelected,
                                                should: guideline.legacyShould
                                            };
                                        });

                                        this.onChange(newGuidelines);
                                    }}
                                />
                            </div>
                        );
                    }
                    return this.renderLegacyGuidelines();
                }}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./components/guidelines_view_or_select/index.js